import { SETTINGS_BODY_DIV } from "../../../assets/styles/classes-constants";
import { BodyDiv } from "../../../components/components-style";
import { Block } from "../main";
import themeIcon from "../../../assets/images/icons/sunny-icon.svg";
import langIcon from "../../../assets/images/icons/earth-outline-icon.svg";
import currencyIcon from "../../../assets/images/icons/dollar-icon.svg";
import timeIcon from '../../../assets/images/icons/structure-object/oclock-icon.svg';
import calendarIcon from '../../../assets/images/icons/calendar-icon.svg';
import { MediumText, TextBody } from "../../../components/typography";
import { GeneralItemBlock } from "../main";
import { themes } from "../../../assets/utils/enums/settings";
import { Button } from "../../../components/ui/button";
import { COLORS } from "../../../assets/utils/enums/colors";
import { useState } from "react";
import {
  ThemeType,
  ThemeTypeEnum,
} from "../../../assets/utils/validation/types";
import { currencies } from "../../../assets/utils/data/items";
import { langs } from "../../../assets/utils/data/langs";
import Dropdown from "../../../components/ui/dropdown";
import { dateFormatData, timeFormatData } from "../../../assets/utils/enums/dropdown";
import { DropdownTypeEnum } from "../../../assets/utils/enums/table";

export default function GeneralSettingsTab() {
  const [checkedTheme, setTheme] = useState<ThemeType>(ThemeTypeEnum.DEFAULT);
  const [checkedLang, setLang] = useState<string>(langs[0].id);
  const [checkedCurrency, setCurrency] = useState<string>(currencies[1].code);
  const [checkedTimeFormat, setTimeFormat] = useState<string>(timeFormatData[0]);
  const [checkedDateFormat, setDateFormat] = useState<string>(dateFormatData[0]);

  return (
    <BodyDiv className={SETTINGS_BODY_DIV} $isPadding={true}>
      <Block
        data-type="general-item"
        className={`w-100 d-flex align-items-center justify-content-between pt-1`}
      >
        <span>
          <img src={themeIcon} alt="theme-icon" />
          <MediumText>Змінити тему</MediumText>
        </span>
        <GeneralItemBlock>
          {themes.map((item) => (
            <Button
              key={item.id}
              bgcolor={checkedTheme === item.id ? item.active[0] : COLORS.gray}
              txtcolor={
                checkedTheme === item.id ? item.active[1] : COLORS.secondary1
              }
              brcolor={"transparent"}
              width="100%"
              type="large"
              brradius="24px"
              className=""
              onClick={() => {
                setTheme(
                  ThemeTypeEnum[
                  item.id.toUpperCase() as keyof typeof ThemeTypeEnum
                  ]
                );
              }}
            >
              <TextBody>{item.name}</TextBody>
            </Button>
          ))}
        </GeneralItemBlock>
      </Block>
      <Block
        data-type="general-item"
        className={`w-100 d-flex align-items-center justify-content-between`}
      >
        <span>
          <img src={langIcon} alt="lang-icon" />
          <MediumText>Змінити мову</MediumText>
        </span>
        <GeneralItemBlock>
          {langs.map((item) => (
            <Button
              key={item.id}
              bgcolor={
                checkedLang === item.id ? COLORS.secondary1 : COLORS.gray
              }
              txtcolor={
                checkedLang === item.id ? COLORS.gray : COLORS.secondary1
              }
              brcolor={"transparent"}
              width="100%"
              type="large"
              brradius="24px"
              className=""
              onClick={() => {
                setLang(item.id);
              }}
            >
              <TextBody>{item.name}</TextBody>
            </Button>
          ))}
        </GeneralItemBlock>
      </Block>
      <Block
        data-type="general-item"
        className={`w-100 d-flex align-items-center justify-content-between`}
      >
        <span>
          <img src={currencyIcon} alt="currency-icon" />
          <MediumText>Вибрати валюту</MediumText>
        </span>
        <GeneralItemBlock>
          {currencies.map((item) => (
            <Button
              key={item.code}
              bgcolor={
                checkedCurrency === item.code ? COLORS.secondary1 : COLORS.gray
              }
              txtcolor={
                checkedCurrency === item.code ? COLORS.gray : COLORS.secondary1
              }
              brcolor={"transparent"}
              width="100%"
              type="large"
              brradius="24px"
              className=""
              onClick={() => {
                setCurrency(item.code);
              }}
            >
              <TextBody>{item.name}</TextBody>
            </Button>
          ))}
        </GeneralItemBlock>
      </Block>
      <Block
        data-type="general-item"
        className={`w-100 d-flex align-items-center justify-content-between`}
      >
        <span>
          <img src={calendarIcon} alt="calendar-icon" />
          <MediumText>Формат дат</MediumText>
        </span>
        <Dropdown
          checkedValue={checkedDateFormat}
          setChecked={setDateFormat}
          type={DropdownTypeEnum.FORMAT_DATE} />
      </Block>
      <Block
        data-type="general-item"
        className={`w-100 d-flex align-items-center justify-content-between`}
      >
        <span>
          <img src={timeIcon} alt="time-icon" />
          <MediumText>Формат часу</MediumText>
        </span>
        <Dropdown
          checkedValue={checkedTimeFormat}
          setChecked={setTimeFormat}
          type={DropdownTypeEnum.FORMAT_TIME} />
      </Block>
    </BodyDiv>
  );
}
